export default function Architecture() {
  const layers = [
    {
      icon: 'ri-radar-line',
      title: '感知层',
      description: '多源传感器数据采集'
    },
    {
      icon: 'ri-wifi-line',
      title: '传输层',
      description: '5G/卫星通信网络'
    },
    {
      icon: 'ri-cpu-line',
      title: '计算层',
      description: 'AI边缘计算处理'
    },
    {
      icon: 'ri-dashboard-line',
      title: '应用层',
      description: '智能决策与展示'
    }
  ];

  return (
    <section id="architecture" className="py-24 bg-gradient-to-b from-[#1a1a2e] to-[#0d1b2a]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* 左侧内容 */}
          <div className="lg:col-span-2">
            <div className="inline-block px-4 py-2 border border-teal-500 rounded-full mb-6">
              <span className="text-teal-400 text-sm tracking-widest">TECHNOLOGY ARCHITECTURE</span>
            </div>
            
            <h2 className="text-5xl md:text-6xl font-black text-white mb-4 leading-tight">
              四层智能<br />感知架构
            </h2>
            
            <p className="text-xl text-gray-400 mb-8">
              从数据采集到智能决策的完整闭环
            </p>

            {/* 层级列表 */}
            <div className="space-y-6 mb-8">
              {layers.map((layer, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500/10 border border-teal-500/30 rounded-lg flex-shrink-0">
                    <i className={`${layer.icon} text-2xl text-teal-400`}></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-white mb-1">{layer.title}</h4>
                    <p className="text-sm text-gray-400">{layer.description}</p>
                  </div>
                  {index < layers.length - 1 && (
                    <div className="ml-6 mt-12 w-px h-6 bg-teal-500/30"></div>
                  )}
                </div>
              ))}
            </div>

            <a href="#" className="inline-flex items-center gap-2 text-teal-400 hover:text-teal-300 transition-colors cursor-pointer">
              <span className="text-sm font-medium">查看技术白皮书</span>
              <i className="ri-download-line"></i>
            </a>
          </div>

          {/* 右侧可视化 */}
          <div className="lg:col-span-3 relative">
            <div className="relative w-full h-[600px]">
              {/* 3D架构图 */}
              <div className="absolute inset-0 flex flex-col justify-center gap-8 perspective-1000">
                {layers.map((layer, index) => (
                  <div
                    key={index}
                    className="relative h-32 bg-gradient-to-r from-teal-500/20 to-teal-500/5 border border-teal-500/40 rounded-lg backdrop-blur-sm"
                    style={{
                      transform: `translateZ(${(3 - index) * 40}px) rotateX(5deg)`,
                      marginLeft: `${index * 20}px`
                    }}
                  >
                    <div className="absolute inset-0 flex items-center justify-between px-8">
                      <div className="flex items-center gap-4">
                        <i className={`${layer.icon} text-3xl text-teal-400`}></i>
                        <div>
                          <h4 className="text-xl font-bold text-white">{layer.title}</h4>
                          <p className="text-sm text-gray-400">{layer.description}</p>
                        </div>
                      </div>
                      
                      {/* 数据流动效果 */}
                      {index < layers.length - 1 && (
                        <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2">
                          <div className="w-1 h-8 bg-gradient-to-b from-teal-400 to-transparent animate-pulse"></div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* 数据指标 */}
              <div className="absolute top-0 right-0 space-y-4">
                <div className="bg-[#141e30]/80 backdrop-blur-sm border border-teal-500/30 rounded-lg p-6">
                  <div className="text-sm text-gray-400 mb-2">覆盖范围</div>
                  <div className="text-4xl font-black text-teal-400">50km²</div>
                </div>
                <div className="bg-[#141e30]/80 backdrop-blur-sm border border-teal-500/30 rounded-lg p-6">
                  <div className="text-sm text-gray-400 mb-2">响应时间</div>
                  <div className="text-4xl font-black text-teal-400">&lt;3min</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}